module.exports = __webpack_public_path__ + "img/download.908694b4.svg";